import { createFileRoute } from '@tanstack/react-router';
import { Leaderboard } from '../features/leaderboard/leaderboard.tsx';
import { Stack } from '@mui/material';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/leaderboard')({
  component: LeaderboardPage,
});

const leaderboardPageSx = createPageBackgroundSx();

function LeaderboardPage() {
  return (
    <Stack sx={leaderboardPageSx}>
      <Leaderboard />
    </Stack>
  );
}
